import type { SailPlotExtensionContext } from "@heiselanalytics/sailplot";

export function PageActions({
  navigate,
  language,
}: Pick<SailPlotExtensionContext, "navigate" | "language">) {
  return (
    <div className="platform-page-actions">
      <button
        type="button"
        className="primary-button"
        onClick={() => navigate("/editor")}
      >
        {language === "de" ? "Editor öffnen" : "Open editor"}
      </button>
    </div>
  );
}
